import {
  SHOW_USER_DETAILS,
  HIDE_USER_DETAILS,
} from '../../constants/ActionTypes';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  userId: '',
};

export default function userdetails(state = initialState, action = {}) {
  switch (action.type) {
    case `${SHOW_USER_DETAILS}`:
      return {
        ...state,
        userId: action.result.userId,
      };

    case `${HIDE_USER_DETAILS}`:
      return {
        ...state,
        userId: '',
      };

    default:
      return state;
  }
}
